import { useNavigate } from 'react-router-dom';

export const useAccess = () => {
    const navigate = useNavigate();

    return {
        accessDefault: () => navigate('/'),
        accessSignIn: () => navigate('/signin'),
        accessSignUp: () => navigate('/signup'),
    };
};
